//Visualizacion del Appointment por Id
(function () {
    'use strict';
    var controllerId = 'appointmentSearchViewCtrl';
  
    //al modulo de controllers le inyecto el nuevo controller declarado en el archivo
    angular
      .module('app.controllers')
      .controller(controllerId, appointmentSearchViewCtrl)
  
    appointmentSearchViewCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$translate', '$state', 'moment'];
  
    function appointmentSearchViewCtrl(common, datacontext, $http, $scope, $translate, $state, moment) {
      let vm = this;
  
      let $parent = $scope.$parent.$parent;
      let appointmentIdSelected = $parent && $parent.appointmentIdSelected;
      let listActionType = $parent && $parent.listActionType;
      let listOperationType = $parent && $parent.listOperationType ;
  
      vm.spinnerOptions = {
        radius: 20,
        lines: 11,
        length: 1,
        width: 8,
        speed: 1.7,
        corners: 1.0,
        trail: 100,
        color: '#146794'
      };
  
      vm.actionRefresh = false;
      vm.appoinments = [];
  
      //fields
      vm.cita = '';
      vm.citaid = '';
      vm.fecha = '';
      vm.hora = '';
      vm.patio = '';
      vm.estado = '';
      vm.placa = '';
      vm.conductor = '';
      vm.empresatransporte = '';
      vm.AppointmentStatusName = '';
      vm.AppointmentStatusColor = '';
  
      var allOfTheData;
  
      //columnas para la grilla del view de la cita especifica
      var columnDefsViewApp = [
        { headerName: $translate.instant('views.appointment.container'), field: "EquipmentNo",  height: 500, border: 0, suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        { headerName: "ISO Code", field: "ISOCode", suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        { headerName: $translate.instant('views.appointment.sizeType'), field: "SizeTypeName",  suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        { headerName: $translate.instant('views.appointment.carrier'), field: "CarrierName",  suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        { headerName: $translate.instant('views.appointment.numberReference'), field: "ReferenceDocumentNo",  suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true },
        { headerName: $translate.instant('views.appointment.depotOrder'), field: "DepotOrderNo",  suppressMenu: true, cellStyle: { 'text-align': 'center' }, suppressSorting: true }
      ];
  
      vm.pageSize = '500';
  
      vm.showPrintApptView = showPrintApptView;
      vm.showPrintApptQR = showPrintApptQR;
  
      //puedo crear otras options para mi grilla distinta
      $scope.gridOptions = {
        virtualPaging: true,
        enableSorting: true,
        enableColResize: true,
        columnDefs: columnDefsViewApp,
        rowData: null,
        cellClicked: cellClickedfunct,
        ready: function (apiWrapper) {
          //apiWrapper.api.sizeColumnsToFit();
        }
      };
  
      init();
  
      function init() {
        vm.actionRefresh = true;
        common.activateController([
          getInitialData()
        ])
          .then(function (arrayData) {
            let data = arrayData[0];
            //los equipments cada uno con su dato de appointment (el mismo)
            allOfTheData = data.Appointment.AppointmentEquipments;
  
            if (data && typeof data != "undefined") {
  
              vm.citaid = data.Appointment.AppointmentId;
              vm.cita = data.Appointment.AppointmentNo;
  
              var Alpha;
              Alpha = data.Appointment.AppointmentDate;
              Alpha = new Date(Alpha);
  
              vm.fecha = moment(Alpha).format("DD/MM/YYYY");
              vm.hora = moment(Alpha).format("HH:mm");
  
              vm.patio = data.Appointment.YardName;
              vm.estado = vm.AppointmentStatusName = data.Appointment.AppointmentStatusName;
              vm.AppointmentStatusColor = data.Appointment.AppointmentStatusColor;
              vm.placa = data.Appointment.LicensePlateNo;
              vm.conductor = data.Appointment.DriverName;
              vm.empresatransporte = data.Appointment.TruckerName;
              for (var i = 0; i < listActionType.length; i++)
                if (data.Appointment.ActionType == listActionType[i].Code)
                  vm.actionType = listActionType[i].Name;
              for (var j = 0; j < listOperationType.length; j++)
                if (data.Appointment.OperationType == listOperationType[j].Code)
                  vm.operationType = listOperationType[j].Name;
            }
            //grilla    
            createNewDatasource();
            vm.actionRefresh = false;
          }, function (err) {
            common.logger.log('error ' + controllerId + ' : ' + err);
          });
      }
  
      function getInitialData() {
        return datacontext.appointment.getAppointmentById(appointmentIdSelected);
      }
  
      function viewCellRendering() {
        return '<i class="fa fa-eye"></i>';
      }
  
      function editCellRendering() {
        return '<i class="fa fa-edit"></i>';
      }
  
      function cellClickedfunct(cell) {
        if (cell.colDef.headerName == 'Editar') {
          var url = $state.href('root.appointmentReport', { parameter: "parameter", userTimeZone: new Date().getTimezoneOffset() });
          window.open(url, '_blank');
        }
      }
  
      //por defecto luego en la definicion del nuevo datasource cambiamos la funcion para este evento a la que corresponda 
      //a nuestra opcion con parametro distinto
      vm.onPageSizeChanged = function () {
        createNewDatasource();
      };
  
      function createNewDatasource() {
  
        if (!allOfTheData) {
          return;
        }
  
        var dataSource = {
  
          rowCount: null,
          pageSize: parseInt(vm.pageSize),
          overflowSize: 100,
          getRows: function (params) {
  
            var rowsThisPage = allOfTheData.slice(params.startRow, params.endRow);
            var lastRow = -1;
            if (allOfTheData.length <= params.endRow) {
              lastRow = allOfTheData.length;
            }
            params.successCallback(rowsThisPage, lastRow);
  
          }
        };
  
        $scope.gridOptions.api.setDatasource(dataSource);
      }    
  
      function showPrintApptView() {
  
        var url = $state.href('root.appointmentReport', { idap: vm.cita, userTimeZone: new Date().getTimezoneOffset() });
        window.open(url, '_blank');
      }
  
      function showPrintApptQR() {
        var url = $state.href('root.appointmentQR', { idap: vm.citaid });
        window.open(url, '_blank');
      }
    }
  
  })();